import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableFormGroup = ({ setFieldValue, iValue, setCuentaInfo, cuentaContableInfo }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContableAltoBajo', salida.value)
      setCuentaInfo(salida.label)
    },
    [setFieldValue, setCuentaInfo]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableAltoBajo', '')
    setCuentaInfo('')
  }, [setFieldValue, setCuentaInfo])

  return (
    <Form.Group>
      <Form.Label text='CUENTA' htmlFor='select-cuentaContable' md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContable' iValue={cuentaContableInfo} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContable' onChange={onChange} />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
